import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import EditProfileModal from "./modals/EditProfileModal";
import ChangePasswordModal from "./modals/ChangePasswordModal";
import LogoutAllDevicesModal from "./modals/LogoutAllDevicesModal";
import ManageSubscriptions from "../modals/ManageSubscriptions";
import ContactSupport from "../modals/ContactSupport";
import DeactivateAccountModal from "./modals/DeactivateAccountModal";

export default function MyAccount() {
  const { user } = useAuthContext();
  const [appUser, setAppUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [showLogoutAllModal, setShowLogoutAllModal] = useState(false);
  const [showManageModal, setShowManageModal] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const appUserResponse = await axios.get(
        `${ApiConnectionString}/api/account`,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      setAppUser(appUserResponse.data);
      setFirstName(appUserResponse.data.firstName);
      setLastName(appUserResponse.lastName);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchData();
    }
  }, [user]);

  if (appUser != null) {
    return (
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            {/* Page title */}
            <h1 className="mb-2">My account</h1>
            <p className="text-muted mb-4">
              Manage your Border City Software account and settings.
            </p>

            {/* Profile */}
            <div className="custom-card-light p-4 rounded-4 mb-4">
              <h5 className="fw-bold mb-3">Profile</h5>

              <p className="mb-1">
                <strong>Name:</strong> {firstName} {lastName}
              </p>
              <p className="mb-1">
                <strong>Email:</strong> {appUser?.email}
              </p>

              <div className="d-flex flex-wrap gap-2 mt-3">
                <button
                  onClick={() => setShowEditProfileModal(true)}
                  className="btn btn-outline-secondary"
                >
                  Edit profile
                </button>
              </div>
            </div>

            {/* Security */}
            <div className="custom-card-light p-4 rounded-4 mb-4">
              <h5 className="fw-bold mb-3">Login & security</h5>

              <p className="text-muted mb-3">
                Manage how you sign in and protect your account.
              </p>

              <div className="d-flex flex-wrap gap-2">
                <button
                  onClick={() => setShowPasswordModal(true)}
                  className="btn btn-outline-secondary"
                >
                  Change password
                </button>
                <button
                  onClick={() => setShowLogoutAllModal(true)}
                  className="btn btn-outline-secondary"
                >
                  Log out of all devices
                </button>
              </div>
            </div>

            {/* Billing */}
            <div className="custom-card-light p-4 rounded-4 mb-4">
              <h5 className="fw-bold mb-3">Billing</h5>

              <p className="text-muted mb-3">
                All payments are handled through Stripe. On the Stripe billing
                portal you can view <strong>invoices</strong>, update your{" "}
                <strong>payment details</strong>, and manage your
                <strong> subscriptions</strong>.
              </p>

              <button
                onClick={() => setShowManageModal(true)}
                className="btn btn-outline-secondary"
              >
                View Stripe billing portal
              </button>
            </div>

            {/* Support */}
            <div className="custom-card-light p-4 rounded-4 mb-4">
              <h5 className="fw-bold mb-3">Support</h5>

              <p className="text-muted mb-3">
                Need help with your websites or your account Send a message and
                I will respond soon.
              </p>

              <button
              onClick={() => setShowSupportModal(true)}
                className="btn brand-purple-inline text-white"
              >
                Contact support
              </button>
            </div>

            {/* Delete Account */}
            <div className="custom-card-light p-4 rounded-4 border-danger mb-5">
              <h5 className="fw-bold text-danger mb-3">Deactivate account</h5>

              <p className="text-muted mb-3">
                Permanently Deactivate your account and all associated websites.
                This cannot be undone.
              </p>

              <button    onClick={() => setShowDeactivateModal(true)} className="btn btn-danger">
                Deactivate my account
              </button>
            </div>
          </div>
        </div>
        {showSupportModal && (
  <>
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <ContactSupport onClose={() => setShowSupportModal(false)} />
      </div>
    </div>
    <div className="modal-backdrop fade show"></div>
  </>
)}

      <DeactivateAccountModal
        show={showDeactivateModal}
        onClose={() => setShowDeactivateModal(false)}
        user={user}
      />
        <EditProfileModal
          show={showEditProfileModal}
          onClose={() => setShowEditProfileModal(false)}
          onSave={(data) => {
            setFirstName(data.firstName);
            setLastName(data.lastName);
          }}
          appUser={appUser}
          user={user}
        />
        <ChangePasswordModal
          show={showPasswordModal}
          onClose={() => setShowPasswordModal(false)}
          user={user}
        />
        <LogoutAllDevicesModal
          show={showLogoutAllModal}
          onClose={() => setShowLogoutAllModal(false)}
        />
        {showManageModal && (
          <>
            <div className="modal fade show d-block" tabIndex="-1">
              <div className="modal-dialog modal-dialog-centered">
                <ManageSubscriptions
                  user={user}
                  onClose={() => setShowManageModal(false)}
                  onSave={async (e) => {
                    setShowManageModal(false);

                    const response = await axios.get(
                      `${ApiConnectionString}/api/BillingPortal`,
                      {
                        headers: { Authorization: `bearer ${user.token}` },
                      }
                    );

                    window.location.href = response.data;
                  }}
                />
              </div>
            </div>
            <div className="modal-backdrop fade show"></div>
          </>
        )}
      </div>
    );
  }
}
